<template>
  <div style class="myclooection">
    <div class="collection">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="小说" name="first">
          <xsCollect></xsCollect>
        </el-tab-pane>
        <el-tab-pane label="漫画" name="second">
          <mhCollect></mhCollect>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="comment-foot">
      <div class="block">
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400"
        ></el-pagination>-->
      </div>
    </div>
  </div>
</template>

<script>
import xsCollect from "./xsCollect.vue";
import mhCollect from "./mhCollect.vue";
export default {
  components: {
    xsCollect,
    mhCollect
  },
  data() {
    return {
      activeName: "first",
      currentPage4: ""
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  beforeCreate() {
    this.$http
      .post("user/getbm/", {
        token: this.$cookies.get("token"),
        type: "book"
      })
      .then(res => {
        if (res.body.code == 1) {
        }
      });
  },
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style>
.myclooection {
  border-radius: 6px;
}

.el-pagination {
  margin-top: 20px;
}

.el-pager li.active {
  color: #28a3b1;
}

.el-pager li:hover {
  color: #28a3b1;
}

.comment-foot {
  width: 900px;
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;
}

.collection {
  padding: 30px;
  width: 900px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px !important;
}

.el-tabs__item {
  font-size: 18px;
  color: #808080;
}

.el-tabs__item.is-active {
  color: #000;
  font-weight: bold;
}

.el-tabs__item:hover {
  color: #000;
}

.el-tabs__active-bar {
  background-color: #28a3b1;
}
.el-tabs__nav-scroll {
  justify-content: flex-start;
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Usercenter/Collection.vue